import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function CookiesPage() {

    const heroData = [
        {
          title: "Cookies & Bars",
          content: "Deliciously baked cookies with crispy edges and soft centers, loaded with your favorite flavors for the perfect treat.",
          image: images.CookiesHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Chocolate Chip Cookie",
        content: "Classic cookie with chocolate chips",
        price: 0,
        image: [
          images.Cookie1,
        ]
      },
      {
        name: "Triple Chocolate Cookie",
        content: "Rich cookie with dark, milk, and white chocolate",
        price: 0,
        image: [
          images.Cookie2,
        ]
      },
      {
        name: "Pistachio White Chocolate Cookie",
        content: "Soft cookie with pistachio pieces and white chocolate chunks",
        price: 0,
        image: [
          images.Cookie3,
        ]
      },
      {
        name: "Salted Caramel Pecan Cookie",
        content: "Chewy cookie with chocolate chips, caramel and toasted pecans with a hint of sea salt",
        price: 0,
        image: [
          images.Cookie4,
        ]
      },
      {
        name: "Double Chocolate Swirl Brownie ",
        content: "Rich, fudgy brownie with a decadent swirl of dark and white chocolate",
        price: 0,
        image: [
          images.Cookie1,
        ]
      },
      {
        name: "Red Velvet Brownie",
        content: "Soft and rich with a hint of cocoa",
        price: 0,
        image: [
          images.Cookie2,
        ]
      },
      {
        name: "Matcha Bars",
        content: "Delicate and earthy, these soft and chewy bars are infused with premium matcha",
        price: 0,
        image: [
          images.Cookie3,
        ]
      },
      {
        name: "Oats Vegan Bar",
        content: "packed with oats, nuts, and natural sweetness for a plant-based energy boost",
        price: 0,
        image: [
          images.Cookie4,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Chocolate Chip Cookie",
        image1: [
          images.Cookie1,
        ],
        content1: "Classic cookie with chocolate chips",
        name2: "Salted Caramel Pecan Cookie",
        image2: [
          images.Cookie4,
        ],
        content2: "Chewy cookie with chocolate chips, caramel and toasted pecans with a hint of sea salt"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
